<template>
    <div class="mission">
       <div class="mission__img">
           <img src="/img/logo-bg.png" alt="HealthNow Logo">
       </div>
       <div class="mission__desc">
           <p class="mission__title">
                Your all-in-one health app for your primary care needs
           </p>
           <p class="mission__txt">
                HealthNow delivers a hassle-free experience by bringing patients and healthcare services in one easy-to-use app.
           </p>
       </div>
    </div>
</template>
<script>
export default {
  name: 'Mission',
};
</script>
